// extracted by mini-css-extract-plugin
export default {"wrapper":"single-line-text-resizer__wrapper___EF1Eq","measureWrapper":"single-line-text-resizer__measureWrapper___o6P60"};